<template>
  <div>
    <client-list v-show="tabType === 1" @handleShow="handleShow" />
    <client-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/>
  </div>
</template>

<script>
import clientList from './list.vue'
import clientShow from './show.vue'
export default {
  components: { clientList,clientShow },
  data() {
    return {
      tabType: 1,
      id: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType=type
      this.id = id
    }
  }
}
</script>

<style>

</style>
